import { render, staticRenderFns } from "./RichMenuButton.vue?vue&type=template&id=036e62f0&scoped=true&"
import script from "./RichMenuButton.vue?vue&type=script&lang=ts&"
export * from "./RichMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./RichMenuButton.vue?vue&type=style&index=0&id=036e62f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e62f0",
  null
  
)

export default component.exports